/**
 * Farben und Reihenfolge der Kategorien - gemeinsam für alle Panels, damit „Spiele"
 * überall dieselbe Farbe hat. Die Farbe hängt am Namen, nie am Rang: ein anderer
 * Zeitraum darf die Balken nicht umfärben.
 *
 * Die acht Farbtöne sind gegen die Panelfläche (#182031) geprüft — Helligkeitsband,
 * Farbigkeit, Rot-Grün-/Blau-Gelb-Sehschwäche und Kontrast. **Die Reihenfolge ist
 * Teil dieser Prüfung**, weil im Stapel nur benachbarte Segmente aneinanderstoßen:
 * Umsortieren heißt nachrechnen (schlechtestes Nachbarpaar liegt bei ΔE 8,4).
 *
 * Neue Kategorien in `Apps:Categories` bekommen hier einen Eintrag — sonst laufen sie
 * ins neutrale Grau und sind von „Sonstiges" nicht mehr zu unterscheiden.
 */
const COLORS: ReadonlyArray<readonly [string, string]> = [
  ["Spiele", "#e66767"],
  ["Video", "#9085e9"],
  ["Musik", "#008300"],
  ["Kommunikation", "#d55181"],
  ["Desktop", "#c98500"],
  ["Web", "#199e70"],
  ["KI", "#d95926"],
  ["Schule", "#3987e5"],
];

/** Sammelbecken: „Sonstiges" und alles Unbekannte bleibt neutral. */
export const OTHER_COLOR = "#8a93a8";

/** Zeit, die vor der Anwendungserfassung gebucht wurde (Clients vor v1.3.0). */
export const UNTRACKED = "nicht erfasst";

const colors = new Map(COLORS);
const ranks = new Map(COLORS.map(([name], index) => [name, index]));

export const categoryColor = (category: string): string => colors.get(category) ?? OTHER_COLOR;

/**
 * Platz im Stapel. Fest, damit sich zwei Tage nebeneinander vergleichen lassen —
 * eine Sortierung nach Größe würde die Segmente täglich durchtauschen.
 * „Sonstiges" und Unbekanntes stehen hinten.
 */
export const categoryRank = (category: string): number =>
  ranks.get(category) ?? (category === "Sonstiges" ? 99 : 90);

/** Sortiert Kategorien in die feste Reihenfolge (Gleichstand: alphabetisch). */
export function byCategoryOrder<T extends { category: string }>(entries: readonly T[]): T[] {
  return [...entries].sort(
    (a, b) =>
      categoryRank(a.category) - categoryRank(b.category) || a.category.localeCompare(b.category, "de"),
  );
}
